module.exports = __webpack_public_path__ + "static/media/csm-small-street-selected.bfb0608c.svg";